import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dt',
  imports: [],
  templateUrl: './dt.component.html',
  styleUrl: './dt.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DtComponent implements OnInit {
  dtApp?: SafeResourceUrl;
  sanitizer = inject(DomSanitizer);
  httpclient = inject(HttpClient);
  constructor() {
    /* this.dtApp = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://cip.connect-test.api.deloitte.ai/public/study_backend/static/index.html?user=1ff7bcb6-3b64-4d3c-80b6-15c5bb7a00e2&id=0000&project=sub_8ea3c73b-bb1f-4422-949f-1b1e7687b98c&key=eXJG3rCH2PpqEu853873CeG3DG7CAkv6&lng=DE&country=DEU&RID=1ff7bcb6-3b64-4d3c-80b6-15c5bb7a00e2'
    ); */
  }
  ngOnInit(): void {
    console.log('0000');

    /*     window.addEventListener('message', event => {
      if (event.data?.iframeHeight) {
        const iframe = document.getElementById('react-iframe') as HTMLIFrameElement;
        if (iframe) {
          iframe.style.height = event.data.iframeHeight + 'px';
        }
      }
    });
  } */
    /*    this.httpclient
      .get('https://cip.connect-test.api.deloitte.ai/public/study_backend/static/index.html', { responseType: 'text' })
      .subscribe({
        next: url => {
          console.log(url);

          this.dtApp = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          console.log('ngoing', this.dtApp);
        },
        error(err) {
          console.log('error', err);
        }
      }); */
  }
}
